import React from 'react'

import CourseContent from 'components/CourseContent'
import CourseDetailsLessonMedia from 'components/CourseDetails/LessonMedia'
import CourseDetailsModuleList from 'components/CourseDetails/ModuleList'
import CourseDetailsResourcesCard from 'components/CourseDetails/ResourcesCard'
import CourseDetailsSkeleton from 'components/CourseDetails/Skeleton'
import CourseDetailsStatCard from 'components/CourseDetails/StatCard'
import CourseDetailsTabs from 'components/CourseDetails/Tabs'
import Button from 'components/Form/Button'
import TrailContextBar from 'components/TrailContextBar'

import useController from './controller'

import {
  CategoryBadge,
  ErrorState,
  HeaderText,
  LayoutGrid,
  LeftColumn,
  LegacyContent,
  LegacyHeader,
  PageRoot,
  RightColumn,
  StatsGrid,
  Title,
} from './styled'

export default function CourseDetails({ portal }) {
  const {
    loading,
    error,
    retry,
    showModularFlow,
    detail,
    legacyCourse,
    selectedLesson,
    modularSubtitle,
    statsCards,
    surveyEndPrompt,
    tabsProps,
    resourceCardProps,
    userId,
    trailContext,
    handleBackToCourses,
    handleBackToTrail,
    handleSelectLesson,
    handleNextTrailItem,
    handlePreviousTrailItem,
    handleToggleFavorite,
    handleVideoCompleted,
  } = useController(portal)

  return (
    <PageRoot>
      {loading ? (
        <CourseDetailsSkeleton />
      ) : error ? (
        <ErrorState>
          <Title>Course unavailable</Title>
          <HeaderText>{error}</HeaderText>
          <Button color="blue" nospace width="fit-content" onClick={retry}>Try again</Button>
        </ErrorState>
      ) : !showModularFlow ? (
        <>
          <TrailContextBar
            context={trailContext}
            onBack={handleBackToTrail}
            onNext={handleNextTrailItem}
            onPrevious={handlePreviousTrailItem}
          />
          <LegacyHeader>
            <div>
              <Title>{legacyCourse?.title}</Title>
              {!legacyCourse?.author ? null : <HeaderText>{legacyCourse.author}</HeaderText>}
            </div>
            {!legacyCourse?.category ? null : <CategoryBadge>{legacyCourse.category}</CategoryBadge>}
          </LegacyHeader>

          <LegacyContent>
            {!legacyCourse ? null : <CourseContent course={legacyCourse} modules={[]} />}
          </LegacyContent>
        </>
      ) : !detail ? (
        <CourseDetailsSkeleton />
      ) : (
        <>
          <TrailContextBar
            context={trailContext}
            onBack={handleBackToTrail}
            onNext={handleNextTrailItem}
            onPrevious={handlePreviousTrailItem}
          />
          <LayoutGrid>
            <LeftColumn>
              {!selectedLesson ? null : (
                <>
                  <CourseDetailsLessonMedia
                    course={detail}
                    lesson={selectedLesson}
                    onBack={handleBackToCourses}
                    onVideoCompleted={handleVideoCompleted}
                    surveyEndPrompt={surveyEndPrompt}
                    userId={userId}
                  />
                  <CourseDetailsTabs key={`${selectedLesson?.moduleId}:${selectedLesson?.id}`} {...tabsProps} />
                </>
              )}
            </LeftColumn>

            <RightColumn>
              <StatsGrid>
                {statsCards.map(item => (
                  <CourseDetailsStatCard key={item.icon} icon={item.icon} label={item.label} value={item.value} />
                ))}
              </StatsGrid>

              <CourseDetailsModuleList
                modules={detail?.modules || []}
                onSelectLesson={handleSelectLesson}
                onToggleFavorite={handleToggleFavorite}
                selectedLessonId={selectedLesson?.id}
                subtitle={modularSubtitle}
              />

              {resourceCardProps?.resources?.length ? (
                <CourseDetailsResourcesCard {...resourceCardProps} />
              ) : null}
            </RightColumn>
          </LayoutGrid>
        </>
      )}
    </PageRoot>
  )
}
